<script>
  import { required, numeric, requiredIf, between } from 'vuelidate/lib/validators'
  const secureKeys = [
    'Backspace',
    'Escape',
    'Enter',
    'ArrowUp',
    'ArrowLeft',
    'ArrowRight',
    'ArrowDown',
    ' ',
    'CapsLock',
    'Shift',
    'Meta',
    'Alt',
    'Control',
    'Tab',
  ];

  let familiar_structure = {
    familiars_name: '',
    familiars_relationship: '',
    familiars_age: ''
  };

  let serious_illness_structure = {
    relation: '',
    illness: ''
  }

  let familiar_medicine_structure = {
    name: '',
    patient: '',
    illness: '',
    amount: '',
    pay_by: ''
  };

  let children_at_other_school_structure = {
    name: '',
    age: '',
    grade: '',
    school: '',
    amount: '',
  };

  let children_at_school_structure = {
    name: '',
    age: '',
    grade: '',
  };

  let car_structure = {
    brand: '',
    model: '',
    year: '',
  };

  let debts_structure = {
    name: '',
    amount: '',
    monthly_amount: '',
    seniority: '',
  };

  let camps_structure = {
    name: '',
    location: '',
    year: '',
    assistant: '',
    amount: '',
  };

  let travels_structure = {
    destination: '',
    travel_days: '',
    family_number: '',
    comments: '',
  };

  export default {
    props: [
      'stepOne',
      'stepTwo',
      'stepThree',
      'stepFour',
      'stepFive',
      'stepSix',
      'stepSeven',
      'stepEight',
      'step',
      'uploader',
    ],
    data() {
      let self = this,
          fullData = {
            active_step: self.$props.step,
            sending: false,
            editing: undefined,
          },
          stepOne = {},
          stepTwo = {},
          stepThree = {},
          stepFour = {},
          stepFive = {},
          stepSix = {},
          stepSeven = {},
          stepEight = {},
          uploader = {
            uploader_options: {
              step: null,
              file: null,
              key: '',
              uploading: false
            }
          };

      // Step 1
      if(self.$props.stepOne != undefined) {
        stepOne = {
          family: self.$props.stepOne.family,
          general_information: {
            father: {
              name: self.$props.stepOne.general_information.father.name,
              first_last_name: self.$props.stepOne.general_information.father.first_last_name,
              second_last_name: self.$props.stepOne.general_information.father.second_last_name,
              age: self.$props.stepOne.general_information.father.age,
              civil_state: self.$props.stepOne.general_information.father.civil_state,
              community: self.$props.stepOne.general_information.father.community,
              street_address: self.$props.stepOne.general_information.father.street_address,
              suburb: self.$props.stepOne.general_information.father.suburb,
              town: self.$props.stepOne.general_information.father.town,
              phone: self.$props.stepOne.general_information.father.phone,
              email: self.$props.stepOne.general_information.father.email,
              actual_job: self.$props.stepOne.general_information.father.actual_job,
            },
            mother: {
              name: self.$props.stepOne.general_information.mother.name,
              first_last_name: self.$props.stepOne.general_information.mother.first_last_name,
              second_last_name: self.$props.stepOne.general_information.mother.second_last_name,
              age: self.$props.stepOne.general_information.mother.age,
              civil_state: self.$props.stepOne.general_information.mother.civil_state,
              community: self.$props.stepOne.general_information.mother.community,
              street_address: self.$props.stepOne.general_information.mother.street_address,
              suburb: self.$props.stepOne.general_information.mother.suburb,
              town: self.$props.stepOne.general_information.mother.town,
              phone: self.$props.stepOne.general_information.mother.phone,
              email: self.$props.stepOne.general_information.mother.email,
              actual_job: self.$props.stepOne.general_information.mother.actual_job,
            },
          },
          number_of_children: self.$props.stepOne.number_of_children,
          number_of_dependents: self.$props.stepOne.number_of_dependents,
          number_of_children_live_with_parents: self.$props.stepOne.number_of_children_live_with_parents,
          grandparents_information: {
            paternal_grandfather: {
              name:             self.$props.stepOne.grandparents_information.paternal_grandfather.name,
              first_last_name:  self.$props.stepOne.grandparents_information.paternal_grandfather.first_last_name,
              second_last_name: self.$props.stepOne.grandparents_information.paternal_grandfather.second_last_name,
              lives:            self.$props.stepOne.grandparents_information.paternal_grandfather.lives,
              phone:            self.$props.stepOne.grandparents_information.paternal_grandfather.phone,
            },
            paternal_grandmother: {
              name:             self.$props.stepOne.grandparents_information.paternal_grandmother.name,
              first_last_name:  self.$props.stepOne.grandparents_information.paternal_grandmother.first_last_name,
              second_last_name: self.$props.stepOne.grandparents_information.paternal_grandmother.second_last_name,
              lives:            self.$props.stepOne.grandparents_information.paternal_grandmother.lives,
              phone:            self.$props.stepOne.grandparents_information.paternal_grandmother.phone,
            },
            maternal_grandfather: {
              name:             self.$props.stepOne.grandparents_information.maternal_grandfather.name,
              first_last_name:  self.$props.stepOne.grandparents_information.maternal_grandfather.first_last_name,
              second_last_name: self.$props.stepOne.grandparents_information.maternal_grandfather.second_last_name,
              lives:            self.$props.stepOne.grandparents_information.maternal_grandfather.lives,
              phone:            self.$props.stepOne.grandparents_information.maternal_grandfather.phone,
            },
            maternal_grandmother: {
              name:             self.$props.stepOne.grandparents_information.maternal_grandmother.name,
              first_last_name:  self.$props.stepOne.grandparents_information.maternal_grandmother.first_last_name,
              second_last_name: self.$props.stepOne.grandparents_information.maternal_grandmother.second_last_name,
              lives:            self.$props.stepOne.grandparents_information.maternal_grandmother.lives,
              phone:            self.$props.stepOne.grandparents_information.maternal_grandmother.phone,
            },
          },
        };
      } else {
        stepOne = {
          family: '',
          general_information: {
            father: {
              name: '',
              first_last_name: '',
              second_last_name: '',
              age: '',
              civil_state: '',
              community: '',
              street_address: '',
              suburb: '',
              town: '',
              phone: '',
              email: '',
              actual_job: '',
            },
            mother: {
              name: '',
              first_last_name: '',
              second_last_name: '',
              age: '',
              civil_state: '',
              community: '',
              street_address: '',
              suburb: '',
              town: '',
              phone: '',
              email: '',
              actual_job: '',
            },
          },
          number_of_children: '',
          number_of_dependents: '',
          number_of_children_live_with_parents: '',
          grandparents_information: {
            paternal_grandfather: {
              name: '',
              first_last_name: '',
              second_last_name: '',
              lives: '',
              phone: '',
            },
            paternal_grandmother: {
              name: '',
              first_last_name: '',
              second_last_name: '',
              lives: '',
              phone: '',
            },
            maternal_grandfather: {
              name: '',
              first_last_name: '',
              second_last_name: '',
              lives: '',
              phone: '',
            },
            maternal_grandmother: {
              name: '',
              first_last_name: '',
              second_last_name: '',
              lives: '',
              phone: '',
            },
          },
        };
      }
      // End Step 1
      // Step 2
      if(self.$props.stepTwo != undefined) {
        stepTwo = {
          father_actual_job: self.$props.stepOne.general_information.father.actual_job,
          house_type: self.$props.stepTwo.house_type,
          borrowed_house_type: self.$props.stepTwo.borrowed_house_type,
          house_monthly_cost: self.$props.stepTwo.house_monthly_cost,
          house_monthly_cost_contribution: self.$props.stepTwo.house_monthly_cost_contribution,
          house_monthly_rent: self.$props.stepTwo.house_monthly_rent,
          house_monthly_rent_contribution: self.$props.stepTwo.house_monthly_rent_contribution,
          house_monthly_expenses_file_rent_url: self.$props.stepTwo.house_monthly_expenses_file_rent_url,
          house_monthly_expenses_file_maintenance_url: self.$props.stepTwo.house_monthly_expenses_file_maintenance_url,
          house_monthly_expenses_file_propertytax_url: self.$props.stepTwo.house_monthly_expenses_file_propertytax_url,
          house_monthly_expenses_file_mortage_url: self.$props.stepTwo.house_monthly_expenses_file_mortage_url,
          includes_maintenance: self.$props.stepTwo.includes_maintenance,
          house_monthly_maintenance: self.$props.stepTwo.house_monthly_maintenance,
          house_monthly_maintenance_contribution: self.$props.stepTwo.house_monthly_maintenance_contribution,
          change_house: self.$props.stepTwo.change_house,
          change_house_explanation: self.$props.stepTwo.change_house_explanation,
          has_common_areas: self.$props.stepTwo.has_common_areas,
          common_areas: self.$props.stepTwo.common_areas,
          rooms: self.$props.stepTwo.rooms,
          has_another_house: self.$props.stepTwo.has_another_house,
        };
      } else {
        stepTwo = {
          father_actual_job: '',
          house_type: null,
          borrowed_house_type: null,
          house_monthly_cost: '',
          house_monthly_cost_contribution: '',
          house_monthly_rent: '',
          house_monthly_rent_contribution: '',
          house_monthly_expenses_file_rent_url: '',
          house_monthly_expenses_file_maintenance_url: '',
          house_monthly_expenses_file_propertytax_url: '',
          house_monthly_expenses_file_mortage_url: '',
          includes_maintenance: null,
          house_monthly_maintenance: '',
          house_monthly_maintenance_contribution: '',
          change_house: null,
          change_house_explanation: '',
          has_common_areas: null,
          common_areas: '',
          rooms: null,
          has_another_house: '',
        };
      }
      // End Step 2
      // Step 3
      if(self.$props.stepThree != undefined) {
        stepThree = {
          father_actual_job: self.$props.stepOne.general_information.father.actual_job,
          has_car: self.$props.stepThree.has_car,
          cars_qty: self.$props.stepThree.cars_qty,
          vehicle_information: (self.$props.stepThree.vehicle_information != undefined) ? self.$props.stepThree.vehicle_information : [],
          circulation_card_files: self.$props.stepThree.circulation_card_files,
          cars_paid: self.$props.stepThree.cars_paid,
          vehicle_total_due_amount: self.$props.stepThree.vehicle_total_due_amount,
          vehicle_monthly_total_amount: self.$props.stepThree.vehicle_monthly_total_amount,
          vehicle_due_contribution: self.$props.stepThree.vehicle_due_contribution,
          has_assurance: self.$props.stepThree.has_assurance,
          vehicle_insurance_amount: self.$props.stepThree.vehicle_insurance_amount,
          vehicle_insurance_amount_contribution: self.$props.stepThree.vehicle_insurance_amount_contribution,
        }; 
      } else {
        stepThree = {
          father_actual_job: '',
          has_car: null,
          cars_qty: '',
          vehicle_information: [],
          circulation_card_files: [],
          cars_paid: null,
          vehicle_total_due_amount: '',
          vehicle_monthly_total_amount: '',
          vehicle_due_contribution: '',
          has_assurance: null,
          vehicle_insurance_amount: '',
          vehicle_insurance_amount_contribution: '',
        };
      }
      // End Step 3
      // Step 4
      if(self.$props.stepFour != undefined) {
        stepFour = {
          father_actual_job: self.$props.stepOne.general_information.father.actual_job,
          mother_actual_job: self.$props.stepOne.general_information.mother.actual_job,
          parents_job_information: {
            father: {
              job_name: self.$props.stepFour.parents_job_information.father.job_name,
              study_name: self.$props.stepFour.parents_job_information.father.study_name,
              boss_name: self.$props.stepFour.parents_job_information.father.boss_name,
              boss_phone: self.$props.stepFour.parents_job_information.father.boss_phone,
              total_commission: self.$props.stepFour.parents_job_information.father.total_commission,
              total_bonus: self.$props.stepFour.parents_job_information.father.total_bonus,
              total_amount: self.$props.stepFour.parents_job_information.father.total_amount,
              last_year_another_income: self.$props.stepFour.parents_job_information.father.last_year_another_income,
              last_year_another_income_name: self.$props.stepFour.parents_job_information.father.last_year_another_income_name,
              last_year_another_income_amount: self.$props.stepFour.parents_job_information.father.last_year_another_income_amount,
              last_year_another_income_periodicity: self.$props.stepFour.parents_job_information.father.last_year_another_income_periodicity,
              this_year_another_income: self.$props.stepFour.parents_job_information.father.this_year_another_income,
              this_year_another_income_name: self.$props.stepFour.parents_job_information.father.this_year_another_income_name,
              this_year_another_income_amount: self.$props.stepFour.parents_job_information.father.this_year_another_income_amount,
              this_year_another_income_periodicity: self.$props.stepFour.parents_job_information.father.this_year_another_income_periodicity,
            },
            mother: {
              job_name: self.$props.stepFour.parents_job_information.mother.job_name,
              boss_name: self.$props.stepFour.parents_job_information.mother.boss_name,
              boss_phone: self.$props.stepFour.parents_job_information.mother.boss_phone,
              total_commission: self.$props.stepFour.parents_job_information.mother.total_commission,
              total_bonus: self.$props.stepFour.parents_job_information.mother.total_bonus,
              total_amount: self.$props.stepFour.parents_job_information.mother.total_amount,
              last_year_another_income: self.$props.stepFour.parents_job_information.mother.last_year_another_income,
              last_year_another_income_name: self.$props.stepFour.parents_job_information.mother.last_year_another_income_name,
              last_year_another_income_amount: self.$props.stepFour.parents_job_information.mother.last_year_another_income_amount,
              last_year_another_income_periodicity: self.$props.stepFour.parents_job_information.mother.last_year_another_income_periodicity,
              this_year_another_income: self.$props.stepFour.parents_job_information.mother.this_year_another_income,
              this_year_another_income_name: self.$props.stepFour.parents_job_information.mother.this_year_another_income_name,
              this_year_another_income_amount: self.$props.stepFour.parents_job_information.mother.this_year_another_income_amount,
              this_year_another_income_periodicity: self.$props.stepFour.parents_job_information.mother.this_year_another_income_periodicity,
            },
          },
          parents_job_father_incomes_file_url: self.$props.stepFour.parents_job_father_incomes_file_url,
          parents_job_mother_incomes_file_url: self.$props.stepFour.parents_job_mother_incomes_file_url,
          goods_and_assets: self.$props.stepFour.goods_and_assets,
          children_working: self.$props.stepFour.children_working,
          children_input_amount: self.$props.stepFour.children_input_amount,
        };
      } else {
        stepFour = {
          father_actual_job: '',
          mother_actual_job: '',
          parents_job_information: {
            father: {
              job_name: '',
              study_name: '',
              boss_name: '',
              boss_phone:'',
              total_commission: '',
              total_bonus: '',
              total_amount: '',
              last_year_another_income: null,
              last_year_another_income_name: '',
              last_year_another_income_amount: '',
              last_year_another_income_periodicity: '',
              this_year_another_income: null,
              this_year_another_income_name: '',
              this_year_another_income_amount: '',
              this_year_another_income_periodicity: '',
            },
            mother: {
              job_name: '',
              boss_name: '',
              boss_phone:'',
              total_commission: '',
              total_bonus: '',
              total_amount: '',
              last_year_another_income: null,
              last_year_another_income_name: '',
              last_year_another_income_amount: '',
              last_year_another_income_periodicity: '',
              this_year_another_income: null,
              this_year_another_income_name: '',
              this_year_another_income_amount: '',
              this_year_another_income_periodicity: '',
            },
          },
          parents_job_father_incomes_file_url: '',
          parents_job_mother_incomes_file_url: '',
          goods_and_assets: '',
          children_working: null,
          children_input_amount: '',
        };
      }
      // End Step 4
      //Step 5
      if(self.$props.stepFive != undefined) {
        stepFive = {
          community_support: {
            katz_jesed_center: self.$props.stepFive.community_support.katz_jesed_center,
            kadurim: self.$props.stepFive.community_support.kadurim,
            fundacion_activa: self.$props.stepFive.community_support.fundacion_activa,
            yad_rajamim: self.$props.stepFive.community_support.yad_rajamim,
            cadis: self.$props.stepFive.community_support.cadis,
            le_mazon: self.$props.stepFive.community_support.le_mazon,
            other: self.$props.stepFive.community_support.other,
            specify: self.$props.stepFive.community_support.specify,

          },
          community_support_comments: {
            katz_jesed_center: self.$props.stepFive.community_support_comments.katz_jesed_center,
            kadurim: self.$props.stepFive.community_support_comments.kadurim,
            fundacion_activa: self.$props.stepFive.community_support_comments.fundacion_activa,
            yad_rajamim: self.$props.stepFive.community_support_comments.yad_rajamim,
            cadis: self.$props.stepFive.community_support_comments.cadis,
            le_mazon: self.$props.stepFive.community_support_comments.le_mazon,
            other: self.$props.stepFive.community_support_comments.other,
            specify: self.$props.stepFive.community_support_comments.specify,

          },
          community_support_amount: {
            katz_jesed_center: self.$props.stepFive.community_support_amount.katz_jesed_center,
            kadurim: self.$props.stepFive.community_support_amount.kadurim,
            fundacion_activa: self.$props.stepFive.community_support_amount.fundacion_activa,
            yad_rajamim: self.$props.stepFive.community_support_amount.yad_rajamim,
            cadis: self.$props.stepFive.community_support_amount.cadis,
            le_mazon: self.$props.stepFive.community_support_amount.le_mazon,
            other: self.$props.stepFive.community_support_amount.other,
          },
          tuition_community_support: self.$props.stepFive.tuition_community_support,
          has_monetary_gift: self.$props.stepFive.has_monetary_gift,
          monetary_gift: self.$props.stepFive.monetary_gift,
        };
      } else {
        stepFive = {
          community_support: {
            katz_jesed_center: '',
            kadurim: '',
            fundacion_activa: '',
            yad_rajamim: '',
            cadis: '',
            le_mazon: '',
            other: '',
            specify: '',
          },
          community_support_comments: {
            katz_jesed_center: '',
            kadurim: '',
            fundacion_activa: '',
            yad_rajamim: '',
            cadis: '',
            le_mazon: '',
            other: '',
            specify: '',
          },
          community_support_amount: {
            katz_jesed_center: '',
            kadurim: '',
            fundacion_activa: '',
            yad_rajamim: '',
            cadis: '',
            le_mazon: '',
            other: '',
          },
          tuition_community_support: '',
          has_monetary_gift: null,
          monetary_gift: '',
        };
      }
      // Step 6
      if(self.$props.stepSix != undefined) {
        stepSix = {
          father_actual_job: self.$props.stepOne.general_information.father.actual_job,
          ill_relatives: (self.$props.stepSix.ill_relatives != undefined) ? self.$props.stepSix.ill_relatives : [],
          medicines: (self.$props.stepSix.medicines != undefined) ? self.$props.stepSix.medicines : [],
          services: {
            water: self.$props.stepSix.services.water,
            light: self.$props.stepSix.services.light,
            gas: self.$props.stepSix.services.gas,
            service: self.$props.stepSix.services.service,
          },
          services_amount: {
            water: self.$props.stepSix.services_amount.water,
            light: self.$props.stepSix.services_amount.light,
            gas: self.$props.stepSix.services_amount.gas,
            service: self.$props.stepSix.services_amount.service,
          },
          has_camp: self.$props.stepSix.has_camp,
          camps: (self.$props.stepSix.camps != null) ? self.$props.stepSix.camps : [],
          first_camp: (self.$props.stepSix.camps != undefined) ? (self.$props.stepSix.camps.length > 0) : false,
          has_foreign_travel : self.$props.stepSix.has_foreign_travel,
          foreign_travel : (self.$props.stepSix.foreign_travel != null) ? self.$props.stepSix.foreign_travel : [],
          first_travel: (self.$props.stepSix.foreign_travel != undefined) ? (self.$props.stepSix.foreign_travel.length > 0) : false,
          owed: self.$props.stepSix.owed,
          debts: (self.$props.stepSix.debts != null) ? self.$props.stepSix.debts : [],
          debts_statement_files: self.$props.stepSix.debts_statement_files,
          has_health_insurance: self.$props.stepSix.has_health_insurance,
          medical_insurance: {
            insurance: self.$props.stepSix.medical_insurance.insurance,
            payment: self.$props.stepSix.medical_insurance.payment,
            pay_by: self.$props.stepSix.medical_insurance.pay_by
          },
          serious_illness_familiar: self.$props.stepSix.serious_illness_familiar,
          familiar_take_medicine: self.$props.stepSix.familiar_take_medicine,
          first_illness_familiar: (self.$props.stepSix.ill_relatives != undefined) ? (self.$props.stepSix.ill_relatives.length > 0) : false,
          first_medicine_familiar: (self.$props.stepSix.medicines != undefined) ? (self.$props.stepSix.medicines.length > 0) : false,
          school_expenses: {
            afternoon_classes: self.$props.stepSix.school_expenses.afternoon_classes,
            afternoon_classes_list: self.$props.stepSix.school_expenses.afternoon_classes_list,
            afternoon_classes_participants: self.$props.stepSix.school_expenses.afternoon_classes_participants,
          },
          school_expenses_total_amount: {
            afternoon_classes: self.$props.stepSix.school_expenses_total_amount.afternoon_classes,
          },
          take_therapies: self.$props.stepSix.take_therapies,
          therapies: {
            names: self.$props.stepSix.therapies.names,
            participants: self.$props.stepSix.therapies.participants,
            amount: self.$props.stepSix.therapies.amount,
          },
          first_debt: (self.$props.stepSix.debts != undefined) ? (self.$props.stepSix.debts.length > 0) : false,
          services_fees_water_file_url: self.$props.stepSix.services_fees_water_file_url,
          services_fees_light_file_url: self.$props.stepSix.services_fees_light_file_url,
          services_fees_gas_file_url: self.$props.stepSix.services_fees_gas_file_url,
        };
      } else {
        stepSix = {
          father_actual_job: '',
          ill_relatives: [],
          medicines: [],
          services: {
            water: '',
            light: '',
            gas: '',
            service: '',
          },
          services_amount: {
            water: '',
            light: '',
            gas: '',
            service: '',
          },
          has_camp: null,
          camps: [],
          first_camp: false,
          has_foreign_travel : null,
          foreign_travel : [],
          first_travel: false,
          owed: null,
          debts: [],
          debts_statement_files: [],
          has_health_insurance: '',
          medical_insurance: {
            insurance: '',
            payment: '',
            pay_by: ''
          },
          serious_illness_familiar: null,
          familiar_take_medicine: null,
          first_illness_familiar: false,
          first_medicine_familiar: false,
          school_expenses: {
            afternoon_classes: null,
            afternoon_classes_list: null,
            afternoon_classes_participants: null,
          },
          school_expenses_total_amount: {
            afternoon_classes: '',
          },
          take_therapies: '',
          therapies: {
            names: null,
            participants: null,
            amount: null,
          },
          first_debt: false,
          services_fees_water_file_url: '',
          services_fees_light_file_url: '',
          services_fees_gas_file_url: '',
        };
      }
      // End Step 6
      // Step 7
      if(self.$props.stepSeven != undefined) {
        
        let newChildren = [];

        if(self.$props.stepSeven.children_at_school !== undefined) {
           self.$props.stepSeven.children_at_school.forEach(function(child) {
            newChildren.push(child);
          });
        }

        let newChildrenAtOtherSchool = [];

        if(self.$props.stepSeven.children_at_other_school !== undefined) {
           self.$props.stepSeven.children_at_other_school.forEach(function(child) {
            newChildrenAtOtherSchool.push(child);
          });
        }

        stepSeven = {
          children_at_school_qty: self.$props.stepSeven.children_at_school_qty,
          first_children_at_school: (self.$props.stepSeven.children_at_school != undefined) ? (self.$props.stepSeven.children_at_school.length > 0) : false,
          children_at_school: newChildren,
          children_at_other_school_qty: self.$props.stepSeven.children_at_other_school_qty,
          first_child_at_other_school: (self.$props.stepSeven.children_at_other_school != undefined) ? (self.$props.stepSeven.children_at_other_school.length > 0) : false,
          children_at_other_school: newChildrenAtOtherSchool,
          school_payment_amount: self.$props.stepSeven.school_payment_amount,
          children_at_other_school_payment_amount: self.$props.stepSeven.children_at_other_school_payment_amount,
        };
      } else {
        stepSeven = {
          children_at_school_qty: null,
          first_children_at_school: false,
          children_at_school: [],
          children_at_other_school_qty: null,
          first_child_at_other_school: false,
          children_at_other_school: [],
          school_payment_amount: '',
          children_at_other_school_payment_amount: '',
        };
      }
      // End Step 7
      // Step 8
      if(self.$props.stepEight != undefined) {
        stepEight = {
          observations: self.$props.stepEight.observations,
          terms_accepted_by: self.$props.stepEight.terms_accepted_by,
          i_declare: self.$props.stepEight.i_declare,
        };
      } else {
        stepEight = {
          observations: '',
          terms_accepted_by: '',
          i_declare: '',
        };
      }
      // End Step 8

      fullData = _.merge(fullData, stepOne, stepTwo, stepThree, stepFour, stepFive, stepSix, stepSeven, stepEight, uploader);

      return fullData;
    },
    validations() {
      let self = this;
      if(self.active_step == 1) {
        return {
          general_information: {
            father: {
              name: {
                required
              },
              first_last_name: {
                required
              },
              second_last_name: {
                required
              },
              age: {
                required
              },
              civil_state: {
                required
              },
              community: {
                required
              },
              street_address: {
                required
              },
              suburb: {
                required
              },
              town: {
                required,
              },
              phone: {
                required
              },
              email: {
                required
              },
              actual_job: {
                required
              },
            },
            mother: {
              name: {
                required
              },
              first_last_name: {
                required
              },
              second_last_name: {
                required
              },
              age: {
                required
              },
              civil_state: {
                required
              },
              community: {
                required
              },
              street_address: {
                required
              },
              suburb: {
                required
              },
              town: {
                required,
              },
              phone: {
                required
              },
              email: {
                required
              },
              actual_job: {
                required
              },
            }
          },
          number_of_children: {
            required,
            numeric,
          },
          number_of_dependents: {
            required,
            numeric,
          },
          number_of_children_live_with_parents: {
            required,
            numeric,
          },
          grandparents_information: {
            paternal_grandfather: {
                name: {
                  required
                },
                first_last_name: {
                  required
                },
                second_last_name: {
                  required
                },
                lives: {
                  required
                },
                phone: {
                  requiredIf: requiredIf(function() {
                  return self.grandparents_information.paternal_grandfather.lives == 'yes' 
                })
              }
            },
            paternal_grandmother: {
                name: {
                  required
                },
                first_last_name: {
                  required
                },
                second_last_name: {
                  required
                },
                lives: {
                  required
                },
                phone: {
                  requiredIf: requiredIf(function() {
                  return self.grandparents_information.paternal_grandmother.lives == 'yes' 
                })
              }
            },
            maternal_grandfather: {
                name: {
                  required
                },
                first_last_name: {
                  required
                },
                second_last_name: {
                  required
                },
                lives: {
                  required
                },
                phone: {
                  requiredIf: requiredIf(function() {
                  return self.grandparents_information.maternal_grandfather.lives == 'yes' 
                })
              }
            },
            maternal_grandmother: {
                name: {
                  required
                },
                first_last_name: {
                  required
                },
                second_last_name: {
                  required
                },
                lives: {
                  required
                },
                phone: {
                  requiredIf: requiredIf(function() {
                  return self.grandparents_information.maternal_grandmother.lives == 'yes' 
                })
              }
            },
          }
        }
      } else if(self.active_step == 2) {
        let step2Validation = {
          house_type: {
            required
          },
          borrowed_house_type: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'borrowed' 
            })
          },
          house_monthly_cost: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'own' 
            }),
            numeric,
          },
          house_monthly_cost_contribution: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'own' 
            })
          },
          house_monthly_rent: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'rent' || self.house_type == 'mortage'
            }),
            numeric,
          },
          house_monthly_rent_contribution: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'rent' || self.house_type == 'mortage'
            })
          },
          includes_maintenance: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'rent' || self.house_type == 'borrowed'
            }),
          },
          house_monthly_maintenance:{
            requiredIf: requiredIf(function() {
              return (self.house_type == 'rent' && self.includes_maintenance == 'no') || (self.house_type == 'borrowed' && self.includes_maintenance == 'no') || self.house_type == 'mortage' || self.house_type == 'own'
            }),
            numeric
          },
          house_monthly_maintenance_contribution: {
            requiredIf: requiredIf(function() {
              return (self.house_type == 'rent' && self.includes_maintenance == 'no') || (self.house_type == 'borrowed' && self.includes_maintenance == 'no') || self.house_type == 'mortage' || self.house_type == 'own'
            }),
          },
          house_monthly_expenses_file_propertytax_url:{
            requiredIf: requiredIf(function() {
              return (self.general_information.father.actual_job != 'more' && self.general_information.father.actual_job != 'avrej') && self.house_type == 'own'
            })
          },
          house_monthly_expenses_file_rent_url:{
            requiredIf: requiredIf(function() {
              return (self.general_information.father.actual_job != 'more' && self.general_information.father.actual_job != 'avrej') && self.house_type == 'rent'
            })
          },
          house_monthly_expenses_file_mortage_url: {
            requiredIf: requiredIf(function() {
              return (self.general_information.father.actual_job != 'more' && self.general_information.father.actual_job != 'avrej') && self.house_type == 'mortage'
            })
          },
          house_monthly_expenses_file_maintenance_url:{
            requiredIf: requiredIf(function() {
              return (self.general_information.father.actual_job != 'more' && self.general_information.father.actual_job != 'avrej' && self.house_type == 'rent' && self.includes_maintenance == 'no') || (self.general_information.father.actual_job != 'more' && self.general_information.father.actual_job != 'avrej' && self.house_type == 'borrowed' && self.includes_maintenance == 'no') || (self.general_information.father.actual_job != 'more' && self.general_information.father.actual_job != 'avrej' && self.house_type == 'mortage' && self.house_monthly_maintenance > 0) || (self.general_information.father.actual_job != 'more' && self.general_information.father.actual_job != 'avrej' && self.house_type == 'own' && self.house_monthly_maintenance > 0)
            })
          },
          change_house: {
            required
          },
          change_house_explanation: {
            requiredIf: requiredIf(function() {
              return self.change_house == 'yes'
            })
          },
          has_common_areas: {
            required
          },
          common_areas: {
            requiredIf: requiredIf(function() {
              return self.has_common_areas == 'yes'
            })
          },
          rooms: {
            required
          },
          has_another_house: {
            required
          },
        };

        return step2Validation;
      } else if(self.active_step == 3) {
        let step3Validation = {
          has_car: {
            required
          },
          cars_qty: {
            requiredIf: requiredIf(function() {
              return self.has_car == 'yes';
            }),
            numeric
          },
          vehicle_information: {
            $each: {
              brand: {
                requiredIf: requiredIf(function() {
                  return self.cars_qty > 0 && self.has_car == 'yes';
                })
              },
              model: {
                requiredIf: requiredIf(function() {
                  return self.cars_qty > 0 && self.has_car == 'yes';
                })
              },
              year: {
                requiredIf: requiredIf(function() {
                  return self.cars_qty > 0 && self.has_car == 'yes';
                })
              },
            }
          },
          cars_paid: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.has_car == 'yes';
            })
          },
          vehicle_total_due_amount: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.cars_paid == 'no' && self.has_car == 'yes';
            }),
            numeric
          },
          vehicle_monthly_total_amount: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.cars_paid == 'no' && self.has_car == 'yes';
            }),
            numeric
          },
          vehicle_due_contribution: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.cars_paid == 'no' && self.has_car == 'yes';
            })
          },
          has_assurance: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.has_car == 'yes';
            })
          },
          vehicle_insurance_amount: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.has_assurance == 'yes' && self.has_car == 'yes';
            }),
            numeric
          },
          vehicle_insurance_amount_contribution: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.has_assurance == 'yes' && self.has_car == 'yes';
            })
          },
          circulation_card_files: {
            requiredIf: requiredIf(function() {
              return self.general_information.father.actual_job != 'more' && self.general_information.father.actual_job != 'avrej' && self.cars_qty > 0 && self.has_car == 'yes';
            })
          }
        };

        return step3Validation;
      } else if(self.active_step == 4) {  
        let step4Validation = {
          children_working: {
            required
          },
          
          parents_job_information: {
            father: {
              job_name: {
                requiredIf: requiredIf(function() {
                  return self.general_information.father.actual_job != 'avrej' && self.general_information.father.actual_job != 'unemployee'
                }),
              },
              study_name: {
                requiredIf: requiredIf(function (){
                  return self.general_information.father.actual_job == 'avrej'
                }),
              },
              boss_name: {
                requiredIf: requiredIf(function() {
                  return self.general_information.father.actual_job != 'profesionist' && self.general_information.father.actual_job != 'avrej' && self.general_information.father.actual_job != 'unemployee'
                }),
              },
              boss_phone: {
                requiredIf: requiredIf(function() {
                  return self.general_information.father.actual_job != 'profesionist' && self.general_information.father.actual_job != 'avrej' && self.general_information.father.actual_job != 'unemployee'
                }),
              },
              total_commission: {
                requiredIf: requiredIf(function() {
                  return self.general_information.father.actual_job == 'commission_agent'
                }),
                numeric
              },
              total_bonus: {
                requiredIf: requiredIf(function() {
                  return self.general_information.father.actual_job != 'unemployee'
                }),
                numeric
              },
              total_amount: {
                requiredIf: requiredIf(function() {
                  return self.general_information.father.actual_job != 'unemployee'
                }),
                numeric
              },
              last_year_another_income: {
                required 
              },
              last_year_another_income_name: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.father.last_year_another_income == 'yes'
                }),
              },
              last_year_another_income_amount: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.father.last_year_another_income == 'yes'
                }),
                numeric
              },
              last_year_another_income_periodicity: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.father.last_year_another_income == 'yes'
                })
              },
              this_year_another_income: {
                required 
              },
              this_year_another_income_name: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.father.this_year_another_income == 'yes'
                }),
              },
              this_year_another_income_amount: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.father.this_year_another_income == 'yes'
                }),
                numeric
              },
              this_year_another_income_periodicity: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.father.this_year_another_income == 'yes'
                }),
              }
            },
            mother: {
              job_name: {
                requiredIf: requiredIf(function() {
                  return self.general_information.mother.actual_job != 'mora' && self.general_information.mother.actual_job != 'housewife'
                }),
              },
              boss_name: {
                requiredIf: requiredIf(function() {
                  return self.general_information.mother.actual_job != 'profesionist' && self.general_information.mother.actual_job != 'mora' && self.general_information.mother.actual_job != 'housewife'
                }),
              },
              boss_phone: {
                requiredIf: requiredIf(function() {
                  return self.general_information.mother.actual_job != 'profesionist' && self.general_information.mother.actual_job != 'mora' && self.general_information.mother.actual_job != 'housewife'
                }),
              },
              total_commission: {
                requiredIf: requiredIf(function() {
                  return self.general_information.mother.actual_job == 'commission_agent'
                }),
                numeric
              },
              total_bonus: {
                requiredIf: requiredIf(function() {
                  return self.general_information.mother.actual_job != 'housewife'
                }),
                numeric
              },
              total_amount: {
                requiredIf: requiredIf(function() {
                  return self.general_information.mother.actual_job != 'housewife'
                }),
                numeric
              },
              last_year_another_income: {
                required 
              },
              last_year_another_income_name: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.mother.last_year_another_income == 'yes'
                }),
              },
              last_year_another_income_amount: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.mother.last_year_another_income == 'yes'
                }),
                numeric
              },
              last_year_another_income_periodicity: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.mother.last_year_another_income == 'yes'
                })
              },
              this_year_another_income: {
                required 
              },
              this_year_another_income_name: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.mother.this_year_another_income == 'yes'
                }),
              },
              this_year_another_income_amount: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.mother.this_year_another_income == 'yes'
                }),
                numeric
              },
              this_year_another_income_periodicity: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.mother.this_year_another_income == 'yes'
                })
              }
            }
          },
          parents_job_father_incomes_file_url: {
            requiredIf: requiredIf(function() {
              return self.general_information.father.actual_job != 'unemployee' && self.general_information.father.actual_job != 'avrej' && self.general_information.father.actual_job != 'more'
            })
          },
          parents_job_mother_incomes_file_url: {
            requiredIf: requiredIf(function() {
              return self.general_information.mother.actual_job != 'housewife' && self.general_information.father.actual_job != 'avrej' && self.general_information.father.actual_job != 'more'
            })
          },
          goods_and_assets: {
            required
          }
        };

        if(self.children_working == 'yes') {
          step4Validation = $.extend(step4Validation, {children_input_amount: {
            required,
            numeric,
          }});
        }

        return step4Validation;
      } else if(self.active_step == 5) {
        let step5Validation = {
          community_support: {
            katz_jesed_center: {
              required
            },
            kadurim: {
              required
            },
            fundacion_activa: {
              required
            },
            yad_rajamim: {
              required
            },
            cadis: {
              required
            },
            le_mazon: {
              required
            },
            other: {
              required
            },
            specify: {
              requiredif: requiredIf(function() {
                return self.community_support.other == 'yes'
              }),
            }
          },
          community_support_comments: {
            katz_jesed_center: {
              requiredif: requiredIf(function() {
                return self.community_support.katz_jesed_center == 'yes'
              })
            },
            kadurim: {
              requiredif: requiredIf(function() {
                return self.community_support.kadurim == 'yes'
              })
            },
            fundacion_activa: {
              requiredif: requiredIf(function() {
                return self.community_support.fundacion_activa == 'yes'
              })
            },
            yad_rajamim: {
              requiredif: requiredIf(function() {
                return self.community_support.yad_rajamim == 'yes'
              })
            },
            cadis: {
              requiredrequiredif: requiredIf(function() {
                return self.community_support.cadis == 'yes'
              })
            },
            le_mazon: {
              requiredif: requiredIf(function() {
                return self.community_support.le_mazon == 'yes'
              })
            },
            other: {
              requiredif: requiredIf(function() {
                return self.community_support.other == 'yes'
              })
            },
          },
          community_support_amount: {
            katz_jesed_center: {
              requiredif: requiredIf(function() {
                return self.community_support.katz_jesed_center == 'yes'
              })
            },
            kadurim: {
              requiredif: requiredIf(function() {
                return self.community_support.kadurim == 'yes'
              })
            },
            fundacion_activa: {
              requiredif: requiredIf(function() {
                return self.community_support.fundacion_activa == 'yes'
              })
            },
            yad_rajamim: {
              requiredif: requiredIf(function() {
                return self.community_support.yad_rajamim == 'yes'
              })
            },
            cadis: {
              requiredrequiredif: requiredIf(function() {
                return self.community_support.cadis == 'yes'
              })
            },
            le_mazon: {
              requiredif: requiredIf(function() {
                return self.community_support.le_mazon == 'yes'
              })
            },
            other: {
              requiredif: requiredIf(function() {
                return self.community_support.other == 'yes'
              })
            },
          },

          tuition_community_support: {
            required
          },

          has_monetary_gift: {
            required
          },

          monetary_gift: {
            requiredif: requiredIf(function() {
                return self.has_monetary_gift == 'yes'
              })
          }

        };
        return step5Validation;
      } else if(self.active_step == 6) {
        let step6Validation = {
          services: {
            water: {
              required
            },
            light: {
              required
            },
            gas: {
              required
            },
            service: {
              required
            },
          },
          services_amount: {
            water: {
              requiredIf: requiredIf(function() {
                return self.services.water == 'yes';
              }),
              numeric,
            },
            light: {
              requiredIf: requiredIf(function() {
                return self.services.light == 'yes';
              }),
              numeric,
            },
            gas: {
              requiredIf: requiredIf(function() {
                return self.services.gas == 'yes';
              }),
              numeric,
            },
            service: {
              requiredIf: requiredIf(function() {
                return self.services.service == 'yes';
              }),
              numeric,
            },
          },
          has_foreign_travel: {
            required
          },
          has_camp: {
            required
          },
          camps: {
            $each: {
              name: {
                requiredIf: requiredIf(function() {
                  return self.has_camp == 'yes';
                })
              },
              location: {
                requiredIf: requiredIf(function() {
                  return self.has_camp == 'yes';
                }),
              },
              year: {
                requiredIf: requiredIf(function() {
                  return self.has_camp == 'yes';
                }),
              },
              assistant: {
                requiredIf: requiredIf(function() {
                  return self.has_camp == 'yes';
                })
              },
              amount: {
                requiredIf: requiredIf(function() {
                  return self.has_camp == 'yes';
                }),
                numeric
              },
            }
          },
          foreign_travel: {
            $each: {
              destination: {
                requiredIf: requiredIf(function() {
                  return self.has_foreign_travel == 'yes';
                })
              },
              travel_days: {
                requiredIf: requiredIf(function() {
                  return self.has_foreign_travel == 'yes';
                }),
                numeric,
              },
              family_number: {
                requiredIf: requiredIf(function() {
                  return self.has_foreign_travel == 'yes';
                }),
                numeric,
              },
              comments: {
                requiredIf: requiredIf(function() {
                  return self.has_foreign_travel == 'yes';
                })
              }
            },
          },
          owed: {
            required
          },
          debts: {
            $each: {
              name: {
                requiredIf: requiredIf(function() {
                  return self.owed == 'yes';
                })
              },
              amount: {
                requiredIf: requiredIf(function() {
                  return self.owed == 'yes';
                }),
                numeric
              },
              monthly_amount: {
                requiredIf: requiredIf(function() {
                  return self.owed == 'yes';
                }),
                numeric
              },
              seniority: {
                requiredIf: requiredIf(function() {
                  return self.owed == 'yes';
                })
              },
            }
          },
          has_health_insurance: {
            required
          },
          medical_insurance: {
            payment: {
              requiredIf: requiredIf(function() {
                return self.has_health_insurance == 'yes';
              }),
              numeric
            }
          },
          serious_illness_familiar: {
            required
          },
          ill_relatives: {
            $each: {
              relation: {
                requiredIf: requiredIf(function() {
                  return self.serious_illness_familiar == 'yes';
                })
              },
              illness: {
                requiredIf: requiredIf(function() {
                  return self.serious_illness_familiar == 'yes';
                })
              },
            }
          },
          familiar_take_medicine: {
            required
          },
          medicines: {
            $each: {
              name: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_medicine == 'yes';
                })
              },
              patient: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_medicine == 'yes';
                })
              },
              illness: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_medicine == 'yes';
                })
              },
              amount: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_medicine == 'yes';
                }),
                numeric
              },
              pay_by: {}
            }
          },
          take_therapies: {
            required
          },
          therapies: {
            names: {
              requiredIf: requiredIf(function() {
                return self.take_therapies == 'yes';
              })
            },
            participants: {
              requiredIf: requiredIf(function() {
                return self.take_therapies == 'yes';
              })
            },
            amount: {
              requiredIf: requiredIf(function() {
                return self.take_therapies == 'yes';
              }),
              numeric
            }
          },
          school_expenses: {
            afternoon_classes: {
              required
            },
            afternoon_classes_list: {
              requiredIf: requiredIf(function() {
                return self.school_expenses.afternoon_classes == 'yes';
              })
            },
            afternoon_classes_participants: {
              requiredIf: requiredIf(function() {
                return self.school_expenses.afternoon_classes == 'yes';
              })
            },
          },
          school_expenses_total_amount: {
            afternoon_classes: {
              requiredIf: requiredIf(function() {
                return self.school_expenses.afternoon_classes == 'yes';
              }),
              numeric
            },
          },
        };

        return step6Validation;
      } else if(self.active_step == 7) {
        let step7Validation = {
          children_at_school_qty: {
            required
          },
          children_at_school: {
            $each: {
              name: {
                requiredIf: requiredIf(function() {
                  return self.children_at_school_qty > 0;
                })
              },
              age: {
                requiredIf: requiredIf(function() {
                  return self.children_at_school_qty > 0;
                }),
                numeric
              },
              grade: {
                requiredIf: requiredIf(function() {
                  return self.children_at_school_qty > 0;
                })
              }
            }
          },
          school_payment_amount: {
            requiredIf: requiredIf(function() {
              return self.children_at_school_qty > 0;
            }),
            numeric,
          },
          children_at_other_school_qty: {
            required
          },
          children_at_other_school: {
            $each: {
              name: {
                requiredIf: requiredIf(function () {
                  return self.children_at_other_school_qty > 0;
                })
              },
              age: {
                requiredIf: requiredIf(function () {
                  return self.children_at_other_school_qty > 0;
                })
              },
              grade: {
                requiredIf: requiredIf(function () {
                  return self.children_at_other_school_qty > 0;
                })
              },
              school: {
                requiredIf: requiredIf(function () {
                  return self.children_at_other_school_qty > 0;
                })
              },
              amount: {
                requiredIf: requiredIf(function () {
                  return self.children_at_other_school_qty > 0;
                })
              },
            }
          },
        };

        return step7Validation;
      } else if(self.active_step == 8) {
        let step8Validation = {
          terms_accepted_by: {
            required
          },
          i_declare: {
            required
          }
        };

        return step8Validation;
      }
    },
    watch: {
      cars_qty: function(val) {
        this.setCars(val);
      },
      editing: function(val) {
        if(this.active_step == 8) {
          // this.refreshPage();
        }
      }
    },
    methods: {
      call_axios: function(url, data) {
        let self = this,
            errorsText = '<ul>',
            errorsContainer = document.querySelector('.error-message--server');

        axios.post(url, {
          data: data
        })
        .then(function(response) {
          if(response.status == 200) {
            errorsContainer.innerHTML = '';
            self.active_step = self.active_step + 1;
          }
          self.sending = false;
        })
        .catch(function(error) {
          self.sending = false;
          for( let key in error.response.data.errors) {
            errorsText += '<li>' + error.response.data.errors[key][0] + '</li>';
          }
          errorsText += '</ul>';
          errorsContainer.innerHTML = errorsText;
          errorsContainer.classList.add('error-message--show');
        });
      },

      send_step_1: function() {
        let self        = this,
            arrayStep1  = {},
            step1URL    = document.querySelector('#step1_url').value,
            family_unique = document.querySelector('#family_unique').value;

        arrayStep1.family                               = family_unique;
        arrayStep1.general_information                  = self.general_information;
        arrayStep1.number_of_children                   = self.number_of_children;
        arrayStep1.number_of_dependents                 = self.number_of_dependents;
        arrayStep1.number_of_children_live_with_parents = self.number_of_children_live_with_parents;
        arrayStep1.grandparents_information             = self.grandparents_information;
        arrayStep1.step                                 = self.active_step;

        this.call_axios(step1URL, arrayStep1);
      },

      send_step_2: function() {
        let self        = this,
            arrayStep2  = {},
            step2URL    = document.querySelector('#step2_url').value;
      
        arrayStep2.house_type                                         = self.house_type;
        arrayStep2.borrowed_house_type                                = self.borrowed_house_type;
        arrayStep2.house_monthly_cost                                 = self.house_monthly_cost;
        arrayStep2.house_monthly_cost_contribution                    = self.house_monthly_cost_contribution;
        arrayStep2.house_monthly_rent                                 = self.house_monthly_rent;
        arrayStep2.house_monthly_rent_contribution                    = self.house_monthly_rent_contribution;
        arrayStep2.house_monthly_expenses_file_rent_url               = self.house_monthly_expenses_file_rent_url;
        arrayStep2.house_monthly_expenses_file_mortage_url            = self.house_monthly_expenses_file_mortage_url;
        arrayStep2.house_monthly_expenses_file_maintenance_url        = self.house_monthly_expenses_file_maintenance_url;
        arrayStep2.house_monthly_expenses_file_propertytax_url        = self.house_monthly_expenses_file_propertytax_url;
        arrayStep2.house_monthly_expenses_file_others_url             = self.house_monthly_expenses_file_others_url;
        arrayStep2.includes_maintenance                               = self.includes_maintenance;
        arrayStep2.house_monthly_maintenance                          = self.house_monthly_maintenance;
        arrayStep2.house_monthly_maintenance_contribution             = self.house_monthly_maintenance_contribution;
        arrayStep2.change_house                                       = self.change_house;
        arrayStep2.change_house_explanation                           = self.change_house_explanation;
        arrayStep2.has_common_areas                                   = self.has_common_areas;
        arrayStep2.common_areas                                       = self.common_areas;
        arrayStep2.rooms                                              = self.rooms;
        arrayStep2.has_another_house                                  = self.has_another_house;
        arrayStep2.step                                               = self.active_step;

        this.call_axios(step2URL, arrayStep2);
      },

      send_step_3: function() {
        let self        = this,
            arrayStep3  = {},
            step3URL    = document.querySelector('#step3_url').value;
        
        arrayStep3.has_car                                = self.has_car;
        arrayStep3.cars_qty                               = self.cars_qty;
        arrayStep3.vehicle_information                    = self.vehicle_information;
        arrayStep3.circulation_card_files                 = self.circulation_card_files;
        arrayStep3.cars_paid                              = self.cars_paid;
        arrayStep3.vehicle_total_due_amount               = self.vehicle_total_due_amount;
        arrayStep3.vehicle_monthly_total_amount           = self.vehicle_monthly_total_amount;
        arrayStep3.vehicle_due_contribution               = self.vehicle_due_contribution;
        arrayStep3.has_assurance                          = self.has_assurance;
        arrayStep3.vehicle_insurance_amount               = self.vehicle_insurance_amount;
        arrayStep3.vehicle_insurance_amount_contribution  = self.vehicle_insurance_amount_contribution;
        arrayStep3.step                                   = self.active_step;

        this.call_axios(step3URL, arrayStep3);
      },

      send_step_4: function() {
        let self        = this,
            arrayStep4  = {},
            step4URL    = document.querySelector('#step4_url').value;

        arrayStep4.parents_job_information              = self.parents_job_information;
        arrayStep4.children_working                     = self.children_working;
        arrayStep4.parents_job_father_incomes_file_url  = self.parents_job_father_incomes_file_url;
        arrayStep4.parents_job_mother_incomes_file_url  = self.parents_job_mother_incomes_file_url;
        arrayStep4.goods_and_assets                     = self.goods_and_assets;
        arrayStep4.children_input_amount                = self.children_input_amount;
        arrayStep4.step                                 = self.active_step;

        this.call_axios(step4URL, arrayStep4);
      },

      send_step_5: function() {
        let self        = this,
            arrayStep5  = {},
            step5URL    = document.querySelector('#step5_url').value;
            
        arrayStep5.community_support                    = self.community_support;
        arrayStep5.community_support_comments           = self.community_support_comments;
        arrayStep5.community_support_amount             = self.community_support_amount;
        arrayStep5.tuition_community_support            = self.tuition_community_support;
        arrayStep5.has_monetary_gift                    = self.has_monetary_gift;
        arrayStep5.monetary_gift                        = self.monetary_gift;
        arrayStep5.step                                 = self.active_step;

        this.call_axios(step5URL, arrayStep5);
      },

      send_step_6: function() {
        let self        = this,
            arrayStep6  = {},
            step6URL    = document.querySelector('#step6_url').value;

        for(let key in self.services) {
          if(self.services[key] == 'no') {
            self.services_amount[key] = null;
          }
        }

        arrayStep6.services                         = self.services;
        arrayStep6.services_amount                  = self.services_amount;
        arrayStep6.has_camp                         = self.has_camp;
        arrayStep6.camps                            = self.camps;
        arrayStep6.camps_total_amount               = self.camps_total_amount;
        arrayStep6.has_foreign_travel               = self.has_foreign_travel;
        arrayStep6.foreign_travel                   = self.foreign_travel;
        arrayStep6.owed                             = self.owed;
        arrayStep6.debts                            = self.debts;
        arrayStep6.debts_total_amount               = self.debts_total_amount;
        arrayStep6.has_health_insurance             = self.has_health_insurance;
        arrayStep6.medical_insurance                = self.medical_insurance;
        arrayStep6.serious_illness_familiar         = self.serious_illness_familiar;
        arrayStep6.ill_relatives                    = self.ill_relatives;
        arrayStep6.familiar_take_medicine           = self.familiar_take_medicine;
        arrayStep6.medicines                        = self.medicines;
        arrayStep6.take_therapies                   = self.take_therapies;
        arrayStep6.therapies                        = self.therapies;
        arrayStep6.debts_statement_files            = self.debts_statement_files;
        arrayStep6.services_fees_water_file_url     = self.services_fees_water_file_url;
        arrayStep6.services_fees_light_file_url     = self.services_fees_light_file_url;
        arrayStep6.services_fees_gas_file_url       = self.services_fees_gas_file_url;
        arrayStep6.school_expenses                  = self.school_expenses;

        for(let key in self.school_expenses) {
          if(self.school_expenses[key] == 'no') {
            self.school_expenses_total_amount[key] = null;
          }
        }

        arrayStep6.school_expenses_total_amount     = self.school_expenses_total_amount;

        arrayStep6.step = self.active_step;

        this.call_axios(step6URL, arrayStep6);
      },

      send_step_7: function() {
        let self        = this,
            arrayStep7  = {},
            step7URL    = document.querySelector('#step7_url').value;

        arrayStep7.children_at_school_qty                   = self.children_at_school_qty;
        arrayStep7.children_at_school                       = self.children_at_school;
        arrayStep7.school_payment_amount                    = self.school_payment_amount;
        arrayStep7.children_at_other_school_qty             = self.children_at_other_school_qty;
        arrayStep7.children_at_other_school                 = self.children_at_other_school;
        arrayStep7.children_at_other_school_payment_amount  = self.children_at_other_school_payment_amount;
        
        

        arrayStep7.step                                     = self.active_step;

        this.call_axios(step7URL, arrayStep7);
      },

      send_step_8: function() {
        let self        = this,
            arrayStep8  = {},
            step8URL    = document.querySelector('#step8_url').value;

        arrayStep8.observations                           = self.observations;
        arrayStep8.terms_accepted_by                      = self.terms_accepted_by;
        arrayStep8.i_declare                              = (self.i_declare == 1) ? 1 : 0;
        arrayStep8.step                                   = self.active_step;

        this.call_axios(step8URL, arrayStep8);
      },

      validateAndAdvance() {
        let self = this;
        let activeStep = this.active_step;

        self.sending = true;

        let $container = document.querySelector('.step-' + activeStep);
        let $inputs = $container.querySelectorAll('.validation-item');

        $inputs.forEach(function($input) {
          self.$v[$input.getAttribute('vue-bind')].$touch();
        });

        if(!self.$v.$error && !self.$v.$invalid) {
          switch(self.active_step) {
            case 1:
              self.send_step_1();
              break;
            case 2:
              self.send_step_2();
              break;
            case 3:
              self.send_step_3();
              break;
            case 4:
              self.send_step_4();
              break;
            case 5:
              self.send_step_5();
              break;
            case 6:
              self.send_step_6();
              break;
            case 7:
              self.send_step_7();
              break;
            case 8:
              self.send_step_8();
              break
          }
        } else {
          self.sending = false;
          console.log('Ocurrió un error');
        }
      },

      getOnTop() {
        window.scrollTo(0, 0);
      },

      getBack() {
        this.active_step = this.active_step - 1;
      },

      setFlagToShowButtons($el, prop) {
        if($el.value != '') {
          this[prop] = true;
        } else {
          this[prop] = false;
        }
      },

      addFamiliar() {
        this.familiars.push(_.clone(familiar_structure));
      },

      addDebt() {
        this.debts.push(_.clone(debts_structure));
      },

      removeDebt() {
        if( this.debts.length > 1) {
          this.debts = this.debts.slice(0, this.debts.length - 1);
        }
      },

      initializeDebts() {
         if( this.debts.length == 0 && this.owed == 'yes' ) {
          this.debts.push(_.clone(debts_structure));
        }
      },

      addCamp() {
        this.camps.push(_.clone(camps_structure));
      },

      removeCamp() {
        if( this.camps.length > 1) {
          this.camps = this.camps.slice(0, this.camps.length - 1);
        }
      },

      initializeCamps() {
         if( this.camps.length == 0 && this.has_camp == 'yes' ) {
          this.camps.push(_.clone(camps_structure));
        }
      },

      addTravel() {
        this.foreign_travel.push(_.clone(travels_structure));
      },

      removeTravel() {
        if( this.foreign_travel.length > 1) {
          this.foreign_travel = this.foreign_travel.slice(0, this.foreign_travel.length - 1);
        }
      },

      initializeTravels() {
         if( this.foreign_travel.length == 0 && this.has_foreign_travel == 'yes' ) {
          this.foreign_travel.push(_.clone(travels_structure));
        }
      },

      addSeriuosIllnessFamiliar() {
        this.ill_relatives.push(_.clone(serious_illness_structure));
      },

      removeSeriuosIllnessFamiliar() {
        if( this.ill_relatives.length > 1 ) {
          this.ill_relatives = this.ill_relatives.slice(0, this.ill_relatives.length - 1);
        }
      },

      initializeSeriousIllnessFamiliar() {
        if( this.ill_relatives.length == 0 && this.serious_illness_familiar == 'yes' ) {
          this.ill_relatives.push(_.clone(serious_illness_structure));
        }
      },

      addFamiliarTakeMedicine($target) {
        this.medicines.push(_.clone(familiar_medicine_structure));
      },

      removeFamiliarTakeMedicine() {
        if( this.medicines.length > 1 ) {
          this.medicines = this.medicines.slice(0, this.medicines.length - 1);
        }
      },

      initializeFamiliarTakeMedicine() {
        if( this.medicines.length == 0 && this.familiar_take_medicine == 'yes' ) {
          this.medicines.push(_.clone(familiar_medicine_structure));
        }
      },

      setChildrenAtSchool() {
        let self = this;
        let tempArr = self.children_at_school;
        self.children_at_school = [];
        for(let i = 1; i <= self.children_at_school_qty; i++ ){
          if(tempArr[i]) {
            self.children_at_school.push(tempArr[i]);
          } else {
            self.children_at_school.push(_.clone(children_at_school_structure));
          }
        }
      },

      setChildrenAtOtherSchool() {
        let self = this;
        let tempArr = self.children_at_other_school;
        self.children_at_other_school = [];
        for(let i = 1; i <= self.children_at_other_school_qty; i++ ){
          if(tempArr[i]) {
            self.children_at_other_school.push(tempArr[i]);
          } else {
            self.children_at_other_school.push(_.clone(children_at_other_school_structure));
          }
        }
      },

      onlyNumeric($event) {
        if (secureKeys.indexOf($event.key) >= 0)
          return false;

        const validate = /^([0-9\.\,\-])$/.test($event.key);

        if (!validate)
          $event.preventDefault();
      },

      setCars(val) {
        let tempArr = this.vehicle_information;
        this.vehicle_information = [];
        for( let i = 1; i <= val; i++) {
          if(tempArr[i]) {
            this.vehicle_information.push(tempArr[i]);
          } else {
            this.vehicle_information.push(_.clone(car_structure));
          }
        }
      },

      setName(value) {
        this.father_name = value
        this.$v.father_name.$touch()
      },

      refreshPage() {
        let self = this;
        if(this.editing != false) {
          setTimeout(function() {
            window.location = self.editing;
          }, 5000);
        }
      },

      uploadButtonFile($event) {
        let event = $event;
        let self = this;
        event.preventDefault();
        if (event.target.dataset.id === undefined || event.target.dataset.id === null || this.uploader_options.file === null) {
          return;
        }
        const key = event.target.dataset.id;

        //ToDo if para tomar el url del boton actual

        self.uploader_options.key = event.target.dataset.id;
        self.uploader_options.uploading = true;

        let formData = new FormData();
        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        }
        formData.append('file', this.uploader_options.file);
        formData.append('field', this.uploader_options.key);

        axios.post('/uploader', formData, config)
          .then(function (response) {
            if (response.data.status === 200 && response.data.field && response.data.file_url) {
              if(key === 'debts_statement_files') {
                self.debts_statement_files.push(response.data.file_url);
                return false;
              }
              if(key === 'circulation_card_files') {
                self.circulation_card_files.push(response.data.file_url);
                return false;
              }
              self[key] = response.data.file_url;
            }
          })
          .then(function() {
            self.resetUploader(key);
            // --
            let $parent = self.findAncestor($event.target, '.form-group--uploader');
            $parent.classList.remove('form-group--uploader-alert');
          })
          .catch(function (error) {
            self.resetUploader(key);
            // --
            let $parent = self.findAncestor($event.target, '.form-group--uploader');

            $parent.querySelector('.alert-danger').innerHTML = `<i class="fa fa-times-circle"></i> ${error.response.data.message} <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>` || '';
          })
      },

      findAncestor (el, sel) {
        while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
        return el;
      },

      onFileSelected($event) {
        this.uploader_options.file = $event.target.files[0];
        // --
        let $parent = this.findAncestor($event.target, '.form-group--uploader');
        $parent.classList.add('form-group--uploader-alert');
        $parent.querySelector('.alert-danger').innerHTML = '';
      },

      resetUploader(id) {
        document.querySelector('#' + id).value = "";
        this.uploader_options = {
          step: null,
          file: null,
          key: '',
          uploading: false
        }
      },
    },
  };

</script>
